import { Pipe, PipeTransform } from '@angular/core';
import { AuthorisationService } from '../services/auth/authorisation.service';
import { Functionalities } from '../services/auth/functionalities';
import { User } from '../user.interface';

@Pipe({
    name: 'hasFunctionality',
    standalone: false,
})
export class HasFunctionalityPipe implements PipeTransform {
    transform(value: Functionalities | Functionalities[], user?: User): boolean {
        if (typeof value === 'object') {
            return AuthorisationService.hasAnyFunctionality(value, user);
        }
        return AuthorisationService.hasFunctionality(value, user);
    }
}
